import { Component } from "react";
import { eraseCookie } from "./helper";
import packageJson from "../package.json";
global.appVersion = packageJson.version;

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    if (a === b) continue;
    return a > b || isNaN(b);
  }
  return false;
};

export default class CacheBuster extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () =>
        caches &&
        caches
          .keys()
          .then(async function (names) {
            await Promise.all(names.map((name) => caches.delete(name)));
          })
          .then(() => localStorage.removeItem("cart"))
          .then(() => eraseCookie("cart"))
          .then(() => window.location.reload()),
    };
  }

  componentDidMount() {
    fetch(`/meta.json?${new Date().getTime()}`, {
      cache: "no-cache",
      "Content-Type": "application/json",
      Accept: "application/json",
    })
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;
        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        );
        shouldForceRefresh
          ? this.setState({ loading: false, isLatestVersion: false })
          : this.setState({ loading: false, isLatestVersion: true });
      })
      .catch(() => window.location.reload());
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload,
    });
  }
}
